import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ({ queryParams }) => {
      const query = new URLSearchParams(queryParams as Record<string, string>).toString();
      return query ? `/products?${query}` : '/products';
    },
  },
];
